import { Component } from "react";
import { withStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import { getTimeString } from "../time";
import Icon from "@mui/material/Icon/Icon";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "./InProgressCard.css";
import { MenuItem, Menu } from "@mui/material";

const styles = (theme) => ({
    root: {
        paddingTop: 16,
        paddingBottom: 16,
        marginTop: theme.spacing(3),
    },
});

class InProgressCard extends Component {
    state = {
        displayContextMenu: false,
        anchorEl: null,
    };

    constructor(props) {
        super(props);

        this.handleButtonPress = this.handleButtonPress.bind(this, this.props.intervention);
        this.handleButtonRelease = this.handleButtonRelease.bind(this);
    }

    componentDidMount() {
        this.divRef.addEventListener("touchstart", this.handleButtonPress, { passive: true });
        this.divRef.addEventListener("mousedown", this.handleButtonPress, { passive: true });
        this.divRef.addEventListener("touchend", this.handleButtonRelease, { passive: true });
        this.divRef.addEventListener("mouseup", this.handleButtonRelease, { passive: true });
        this.divRef.addEventListener("mouseleave", this.handleButtonRelease, { passive: true });
    }

    componentWillUnmount() {
        this.divRef.removeEventListener("touchstart", this.handleButtonPress, { passive: true });
        this.divRef.removeEventListener("mousedown", this.handleButtonPress, { passive: true });
        this.divRef.removeEventListener("touchend", this.handleButtonRelease, { passive: true });
        this.divRef.removeEventListener("mouseup", this.handleButtonRelease, { passive: true });
        this.divRef.removeEventListener("mouseleave", this.handleButtonRelease, { passive: true });
    }

    handleButtonPress(intervention, event) {
        let target = event.currentTarget;
        this.buttonPressTimer = setTimeout(() => {
            this.setState({ anchorEl: target });
            this.openContextMenu(intervention);
        }, 1500);
    }

    handleButtonRelease() {
        clearTimeout(this.buttonPressTimer);
    }

    openContextMenu() {
        this.setState({ displayContextMenu: true });
    }

    closeContextMenu() {
        this.setState({
            displayContextMenu: false,
            anchorEl: null,
        });
    }

    stopImputation() {
        this.props.stop();
        this.closeContextMenu();
    }

    render() {
        return (
            <div>
                <Card
                    className="card col-lg-12 col-md-12 col-sm-12 col-12 card-fluide without-side-margin"
                    ref={(divRef) => (this.divRef = divRef)}
                >
                    <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding">
                            <Typography
                                component="p"
                                style={{
                                    textAlign: "center",
                                    color: "#001A70",
                                    fontSize: (35 * window.innerHeight) / 1000,
                                    fontWeight: "bold",
                                    width: "100%",
                                    padding: "2px",
                                    fontFamily: "EDF2020_Bold",
                                }}
                            >
                                {this.props.imputation.activity.name}
                            </Typography>
                            <Typography
                                component="p"
                                style={{
                                    textAlign: "center",
                                    color: "#001A70",
                                    fontSize: (25 * window.innerHeight) / 1000,
                                    width: "100%",
                                    padding: "2px",
                                }}
                            >
                                En cours
                            </Typography>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding">
                            <Typography
                                component="p"
                                style={{
                                    marginBottom: "auto",
                                    marginTop: "auto",
                                    textAlign: "center",
                                    color: "#FF6D00",
                                    fontSize: (28 * window.innerHeight) / 1000,
                                    verticalAlign: "middle",
                                    padding: "2px",
                                }}
                            >
                                depuis
                            </Typography>
                            <Typography
                                component="p"
                                style={{
                                    marginBottom: "auto",
                                    marginTop: "auto",
                                    textAlign: "center",
                                    color: "#FF6D00",
                                    fontSize: (35 * window.innerHeight) / 1000,
                                    fontWeight: "bold",
                                    verticalAlign: "middle",
                                    padding: "2px",
                                    fontFamily: "EDF2020_Bold",
                                }}
                            >
                                {getTimeString(this.props.imputation.date_start).replace("h", ":")}
                            </Typography>
                        </div>
                    </CardContent>
                </Card>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <Menu
                        id="menu-appbar"
                        anchorEl={this.state.anchorEl}
                        keepMounted
                        className="col-lg-12 col-md-12 col-sm-12 col-12"
                        open={this.state.displayContextMenu}
                        onClose={this.closeContextMenu.bind(this)}
                    >
                        <MenuItem onClick={this.stopImputation.bind(this)}>
                            <Icon className="red-icon">stop</Icon>
                            {"Arrêter l'imputation en cours"}
                        </MenuItem>
                    </Menu>
                </div>
            </div>
        );
    }

    GetStopButton() {
        let length = 20;
        let offset = 2;
        let small = length / (1 + Math.sqrt(2));
        let p0 = [(length - small) / 2 + offset, offset];
        let p1 = [(length - small) / 2 + small + offset, offset];
        let p2 = [length + offset, (length - small) / 2 + offset];
        let p3 = [length + offset, (length - small) / 2 + small + offset];
        let p4 = [(length - small) / 2 + small + offset, length + offset];
        let p5 = [(length - small) / 2 + offset, length + offset];
        let p6 = [offset, (length - small) / 2 + small + offset];
        let p7 = [offset, (length - small) / 2 + offset];
        let result = "M" + p0[0] + " " + p0[1] + " ";
        result += "L" + p1[0] + " " + p1[1] + " ";
        result += "L" + p2[0] + " " + p2[1] + " ";
        result += "L" + p3[0] + " " + p3[1] + " ";
        result += "L" + p4[0] + " " + p4[1] + " ";
        result += "L" + p5[0] + " " + p5[1] + " ";
        result += "L" + p6[0] + " " + p6[1] + " ";
        result += "L" + p7[0] + " " + p7[1] + " Z";
        return result;
    }
}

export default withStyles(styles)(InProgressCard);
